type ReportBaseKeyArgs = {
  websiteId: string;
  reportBlockId: string;
  feature: string;
};

export class StorageKeysManager {
  static createReportBasedKey({ websiteId, reportBlockId, feature }: ReportBaseKeyArgs): string {
    return `twipla-${websiteId}-${reportBlockId}-${feature}`;
  }

  static createWebsiteBasedKey({ websiteId, feature }: { websiteId: string; feature: string }) {
    return `twipla-${websiteId}-${feature}`;
  }

  static createNamespaceBasedKey({ namespace, feature }: { namespace: string; feature: string }) {
    return `twipla-${namespace}-${feature}`;
  }

  static getReportFilterConditionsKey({
    namespace,
    reportBlockId,
  }: {
    namespace: string;
    reportBlockId: string;
  }): string {
    return this.createNamespaceBasedKey({ namespace, feature: `${reportBlockId}-applied-filter-conditions` });
  }

  static getReportSegmentsKey({ namespace, reportBlockId }: { namespace: string; reportBlockId: string }) {
    return this.createNamespaceBasedKey({ namespace, feature: `${reportBlockId}-applied-segments` });
  }

  static getTimePeriodKey(websiteId: string) {
    return this.createWebsiteBasedKey({ websiteId, feature: 'time-period' });
  }

  static getColumnVisibilityKey({
    namespace,
    reportBlockId,
    view,
  }: {
    namespace: string;
    reportBlockId: string;
    view: string;
  }): string {
    return this.createNamespaceBasedKey({ namespace, feature: `${reportBlockId}-${view}-column-visibility` });
  }

  static getColumnSizingKey({
    namespace,
    reportBlockId,
    view,
  }: {
    namespace: string;
    reportBlockId: string;
    view: string;
  }): string {
    return this.createNamespaceBasedKey({ namespace, feature: `${reportBlockId}-${view}-column-sizing` });
  }

  static getDataViewKey({ namespace, identifier }: { namespace: string; identifier: string }) {
    return this.createNamespaceBasedKey({ namespace, feature: `data-view-for-${identifier}` });
  }

  static getDataViewTogglesKey({ namespace, identifier }: { namespace: string; identifier: string }) {
    return this.createNamespaceBasedKey({ namespace, feature: `data-view-toggles-for-${identifier}` });
  }

  static getReportSortingKey({ namespace, reportBlockId }: { namespace: string; reportBlockId: string }) {
    return this.createNamespaceBasedKey({ namespace, feature: `${reportBlockId}-sorting` });
  }

  static getHiddenKpisKey({ namespace, reportBlockId }: { namespace: string; reportBlockId: string }) {
    return this.createNamespaceBasedKey({ namespace, feature: `${reportBlockId}-hidden-kpis` });
  }

  static getTodayDateKey() {
    return `twipla-todays-date`;
  }
}
